import React, { createContext, useState, useRef, useEffect } from 'react'; // useRef for video content
import { io } from 'socket.io-client';
import Peer from 'simple-peer';

const SocketContext = createContext();

const socket = io('https://partner-video-chat-app.herokuapp.com/'); // passing in the string of our backend server

const ContextProvider = ({ children }) => {
    // we are passing all the vars in the useState below to the components
    const [stream, setStream] = useState(null);
    const [me, setMe] = useState('');
    const [call, setCall] = useState({});
    const [callAccepted, setCallAccepted] = useState(false);
    const [callEnded, setCallEnded] = useState(false);
    const [name, setName] = useState('');
    // need to immediately populate that video iframe with the src of our stream
    const myVideo = useRef();
    const userVideo = useRef();
    const connectionRef = useRef();
    //  tell React that your component needs to do something after the page render(load)(it mounts)
    // gets permission to use the video and audio from the  user's camera and microphone
    useEffect(() => {
        // requesting permission from the user
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }) // navigator is a built-in component
            .then((currentStream) => {
                setStream(currentStream);

                myVideo.current.srcObject = currentStream;
            });
        
        // we emit our id asa the connection opens in the backend, we listen to it in the frontend
        socket.on('me', (id) => setMe(id));
        // receive the emit calluse from the backend and listen to it in the frontend
        socket.on('calluser', ({ from, name: callerName, signal }) => { // receive the data
            setCall({ isReceivedCall: true, from, name: callerName, signal });
        });
    }, []); // must have an empty dependency array [] at the end otherwise it will keep on running

    const answerCall = () => {
        setCallAccepted(true);

        // peer for video call
        const peer = new Peer({ initiator: false, trickle: false, stream}); // initiator is false since we are not creating a call but answering it

        peer.on('signal', (data) => {
            socket.emit('answercall', { signal: data, to: call.from }); // emit to the backend answercall
        });

        peer.on('stream', (currentStream) => {
            userVideo.current.srcObject = currentStream; // the other call's stream, not our own stream in useEffect
        });

        peer.signal(call.signal); // get the signal from the setCall function in the useEffect

        connectionRef.current = peer;
    }

    const callUser = (id) => {
        // peer for video call
        const peer = new Peer({ initiator: true, trickle: false, stream}); // initiator is true since we are creating a call 

        peer.on('signal', (data) => {
            socket.emit('calluser', { userToCall: id, signalData: data, from: me, name }); // emit to the backend calluser
        });

        peer.on('stream', (currentStream) => {
            userVideo.current.srcObject = currentStream; // the other call's stream, not our own stream in useEffect
        });

        socket.on('callaccepted', (signal) => { // listen to callaccepted from the backend
            setCallAccepted(true); 

            peer.signal(signal);
        });

        connectionRef.current = peer;
    }

    const leaveCall = () => {
        setCallEnded(true);

        connectionRef.current.destroy();

        window.location.reload(); // provide user with a new id from line 33
    }

    // Every Context object comes with a Provider React component that allows consuming components to subscribe to context changes
    return (
        <SocketContext.Provider value={{ call, callAccepted, myVideo, userVideo, stream, name, setName, callEnded, me, callUser, leaveCall, answerCall}}> {/* content object in the value attribute is globally accessible to all of the components */}
            {children} {/* all of the components are wrapped inside here */}
        </SocketContext.Provider>
    );
};

export { ContextProvider, SocketContext };

